import { makeAutoObservable } from 'mobx';
import ITask from "../../models/task";
import FilesService from "../../services/files-service";
import Subjects from '../../models/subjects';

export default class TaskItemStore {

    data: ITask;

    subject: Subjects;

    expanded: boolean;

    filesService: FilesService;

    constructor(data: ITask, subject: Subjects) {
        this.data = data;
        this.expanded = false;
        this.subject = subject;
        this.filesService = new FilesService();
        makeAutoObservable(this);
    }
 
    toggle() {
        this.expanded = !this.expanded;
    }

    getUrl(fileId: string): string {
        return this.filesService.getFileUrl(fileId);
    }
}